import { gql } from '@grandvisionhq/graphql';

const inviteeFragment = gql`
  fragment InviteeFragment on AppointmentCustomer {
    firstName
    lastName
    email
    phone
  }
`;
const childFragment = gql`
  fragment ChildFragment on AppointmentChild {
    firstName
    lastName
  }
`;
const storeInfoFragment = gql`
  fragment StoreInfoFragment on Store {
    streetName
    streetNumber
    town
    name
    code
    phone
    postalCode
    country
    lat
    lon
  }
`;
const appointmentTypeFragment = gql`
  fragment AppointmentTypeFragment on AppointmentType {
    id
    name
    label
    description
    ageGroup
    duration {
      amount
      unit
    }
  }
`;
var AccountAppointmentFragment = gql`
  fragment AccountAppointmentFragment on Appointment {
    id
    invitee {
      ...InviteeFragment
    }
    child {
      ...ChildFragment
    }
    appointmentType {
      ...AppointmentTypeFragment
    }
    startTime
    endTime
    isCancellable
    isReschedulable
    isReservation
    storeInfo {
      ...StoreInfoFragment
    }
    customerComment
  }
  ${inviteeFragment}
  ${childFragment}
  ${storeInfoFragment}
  ${appointmentTypeFragment}
`;

export { appointmentTypeFragment, childFragment, AccountAppointmentFragment as default, inviteeFragment, storeInfoFragment };
//# sourceMappingURL=appointment.js.map
